// "1 line" / "58 lines". Pass an explicit plural for words that don't take a
// trailing s ("1 case couldn't be read" / "2 cases", but "1 box" / "2 boxes").
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return count === 1 ? singular : plural;
}
